import PropTypes from 'prop-types';
import { Page } from 'framework7-react';
import React, { useEffect } from 'react';

import { I18n } from 'Locales';
import { mockFunction } from 'Helpers';
import { NavigationService } from 'Services';
import { AppHeader, Pagination } from 'Components';
import { ADMIN_ROLES, DAILY_FIGURES_CAMPAIGNS, PAGE_NAMES, TABLE_CONFIG } from 'Constants';

import Charity from './views/Charity';
import Commercial from './views/Commercial';

const handleGoBack = resetTransient => {
  resetTransient();
  NavigationService.goBack({ name: PAGE_NAMES.DAILY_FIGURES });
};

const handlePaginationNavigation = (defaultParams, filters, getAdminDailyFigures, sort) => {
  getAdminDailyFigures({ ...filters, ...sort, ...defaultParams });
};

const CampaignsView = ({
  adminDailyFigures = {},
  adminFilters = {},
  dailyFigures = {},
  getAdminDailyFigures = mockFunction,
  getCampaignsByClientType = mockFunction,
  resetTransient = mockFunction,
  transient = {},
  updateDailyFiguresProps = mockFunction,
  updateTransientProps = mockFunction,
  updateUserProps = mockFunction,
  userAdminFilters = {},
  userRole = '',
  view = ''
}) => {
  const { meta = {} } = dailyFigures;
  const {
    campaignType = '',
    filters = {},
    getAdminDailyFiguresLoading = false,
    selectedMcPin = '',
    sort = {}
  } = transient;
  const { mc_pins = [] } = filters;
  const startDate = filters?.dailyFiguresDate_start_date;
  const endDate = filters?.dailyFiguresDate_end_date;
  const pins = userRole === ADMIN_ROLES.ADMIN ? mc_pins : selectedMcPin;

  useEffect(() => {
    if (!startDate || !endDate) return;
    getCampaignsByClientType({ type: campaignType, pins: pins });
  }, [startDate, endDate]);

  return (
    <Page id={'campaigns-view'}>
      <AppHeader
        goBack
        hideAvatar
        showMcPins={false}
        title={I18n.t('admin:campaignsViews.campaignsView')}
        handleClick={handleGoBack.bind(null, resetTransient)}
      />

      <>
        {adminDailyFigures.campaignsName === DAILY_FIGURES_CAMPAIGNS.CHARITY_CAMPAIGNS ? (
          <Charity
            adminDailyFigures={adminDailyFigures}
            adminFilters={adminFilters}
            getAdminDailyFigures={getAdminDailyFigures}
            transient={transient}
            updateDailyFiguresProps={updateDailyFiguresProps}
            updateTransientProps={updateTransientProps}
            updateUserProps={updateUserProps}
            userAdminFilters={userAdminFilters}
            userRole={userRole}
            view={view}
          />
        ) : (
          <Commercial
            adminDailyFigures={adminDailyFigures}
            adminFilters={adminFilters}
            getAdminDailyFigures={getAdminDailyFigures}
            transient={transient}
            updateTransientProps={updateTransientProps}
            updateUserProps={updateUserProps}
            userAdminFilters={userAdminFilters}
            userRole={userRole}
            view={view}
          />
        )}

        <Pagination
          loading={getAdminDailyFiguresLoading}
          totalNumberOfPages={meta?.total_pages}
          onNavigate={handlePaginationNavigation.bind(null, filters, sort, getAdminDailyFigures)}
          numberOfElements={TABLE_CONFIG.ROWS}
          externalPageNumber={meta?.page}
        />
      </>
    </Page>
  );
};

CampaignsView.propTypes = {
  adminDailyFigures: PropTypes.object,
  adminFilters: PropTypes.object,
  dailyFigures: PropTypes.object,
  getAdminDailyFigures: PropTypes.func,
  getCampaignsByClientType: PropTypes.func,
  resetTransient: PropTypes.func,
  transient: PropTypes.object,
  updateDailyFiguresProps: PropTypes.func,
  updateTransientProps: PropTypes.func,
  updateUserProps: PropTypes.func,
  userAdminFilters: PropTypes.object,
  userRole: PropTypes.string,
  view: PropTypes.string
};

export default CampaignsView;
